/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

import { Card, FormControl, Grid, InputLabel, MenuItem, Select, TextField } from "@mui/material";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { appConstants } from "utils/appConstants";
import { blank, getScreenRight, showResMsg, validateField } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import { addParameterSettingsData, getParameterSettingById, updateParameterSettingsData } from "utils/superAdminApi";
const { default: DashboardLayout } = require("examples/LayoutContainers/DashboardLayout");

const errMsg = {
  color: `red`,
  fontSize: `11px`,
};

let routePath = "/parametersetting";



let LOGIN_DETAILS;
let fetchedUser;

function AddParameterSettings(addProps) {
  let mandateFlag = false;

  const { id } = useParams();
  const [screenName, setScreenName] = useState("Add New Parameter Setting");
  const [parameterNameErr, setParameterNameErr] = useState(false);
  const [parameterCodeErr, setParameterCodeErr] = useState(false);
  const [parameterTypeErr, setParameterTypeErr] = useState(false);
  const [parameterLengthErr, setParameterLengthErr] = useState(false);
  const [parameterValueErr, setParameterValueErr] = useState(false);
  const [parameterValueErr1, setParameterValueErr1] = useState(false);
  const [disableColor, setDisableColor] = useState(false);

  const [controller] = useMaterialUIController();
  const { sidenavColor, darkMode } = controller;
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const [values, setValues] = React.useState({
    parameterValue: "",
    parameterLength: "",
    parameterType: "String",
    parameterCode: "",
    parameterName: "",
    parameterStatus: "Active",
    parameterInstructions: "",
    id: "",
    userType: "Admin",
    loginURL: appConstants.loginURL,
  });


  const handleChange = (name) => (event) => {
    if (name == "parameterCode") {
      setValues({ ...values, [name]: event.target.value.toUpperCase() });
      return
    }
    if (event.target.validity !== undefined && event.target.validity.valid === true) {
      setValues({ ...values, [name]: event.target.value });
    }
    else if (event.target.validity === undefined) {
      setValues({ ...values, [name]: event.target.value });
    }
  };


  useEffect(() => {
    id === undefined ? setScreenName("Add New Parameter Setting") : setScreenName("Edit Parameter Settings");
    (async () => {
      getRight()
      if (id !== undefined) {
        values._id = id
        getParameterSettingById({ id: values._id }, (data) => {
          setValues(data.Result_Output[0]);
        }, dispatch)
      }
    }
    )();
  }, [dispatch])



  async function getRight() {
    let right = await getScreenRight("Parameter Settings")
    if (right === "Full Access") {
      setDisableColor(false)
    }
    else setDisableColor(true)

  }


  useEffect(() => {
    if (id === undefined) {
      setValues({ ...values, 'parameterValue': '' })
    }

  }, [values.parameterType, values.parameterLength])

  const clearErrorStates = () => {
    setParameterNameErr(false);
    setParameterCodeErr(false);
    setParameterTypeErr(false);
    setParameterLengthErr(false);
    setParameterValueErr(false);
  };

  const ParameterSettingsData = async () => {
    let mandateFlag = false;
    clearErrorStates();
    mandateFlag = validateField(values.parameterName, setParameterNameErr) || mandateFlag;
    mandateFlag = validateField(values.parameterCode, setParameterCodeErr) || mandateFlag;
    mandateFlag = validateField(values.parameterType, setParameterTypeErr) || mandateFlag;
    if (values.parameterType !== "On/Off") {
      mandateFlag = validateField(values.parameterLength, setParameterLengthErr, mandateFlag)
      mandateFlag = validateField(values.parameterValue, setParameterValueErr) || mandateFlag;
    } else {
      mandateFlag = validateField(values.parameterValue, setParameterValueErr) || mandateFlag;

      if (values.parameterValue) {
        if (parseInt(values.parameterValue) > 1) {
          setParameterValueErr1(true)
          mandateFlag = true
        } else {
          setParameterValueErr1(false)

        }
      }

    }

    if (mandateFlag) {
      return;
    }

    const apiFunction = id === undefined ? addParameterSettingsData : updateParameterSettingsData;
    apiFunction(values, (data) => {
      if (data.Result_Status) {
        showResMsg(id === undefined ? genericMessage.added : genericMessage.updated, 1000, data.Result_Status, navigate, routePath);
      } else {
        showResMsg(data.Result_Message, 2000, data.Result_Status);
      }
    }, dispatch);
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);


  const handleKeyDown = (e) => {
    const inputElement = document.querySelector('.GoogleInput');
    if (e.key === "Enter" && inputElement && inputElement.contains(e.target)) {
      e.preventDefault();
    }
  };


  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox mt={6} mb={3}>
        <Grid container spacing={1} style={{ display: "flex", justifyContent: "center" }}>
          <Grid item lg={6} xs={12}>
            <Card sx={{ boxShadow: "none" }}>
              <MDBox
                mx={2}
                mt={-3}
                mb={1.5}
                py={2}
                px={2}
                variant="gradient"
                bgColor={sidenavColor}
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  {screenName}
                </MDTypography>
              </MDBox>
              <Grid
                container
                p={1.6}
                mb={0.9}
                px={2}
                columnSpacing={{ xs: 2, sm: 2, md: 3, lg: 3 }}
                rowSpacing={{ xs: 2, sm: 2, md: 3, lg: 3 }}
              >
                <Grid item lg={6} xs={12}>
                  <TextField
                    type="text"
                    label="Parameter Name"
                    variant="outlined"
                    fullWidth
                    autoFocus={true}
                    disabled={id ? true : false}
                    value={values.parameterName}
                    onChange={handleChange("parameterName")}
                    inputProps={{
                      pattern: "^[a-zA-Z0-9 ]+$",
                      maxLength: 50
                    }}
                  />
                  {parameterNameErr ? <span style={errMsg}>Parameter Name can't be blank</span> : ""}
                </Grid>
                <Grid item lg={6} xs={12}>
                  <TextField
                    type="text"
                    label="Parameter Code"
                    variant="outlined"
                    fullWidth
                    disabled={id ? true : false}
                    value={values.parameterCode}
                    onChange={handleChange("parameterCode")}
                    inputProps={{
                      pattern: "^[a-zA-Z0-9]+$",
                      maxLength: 20
                    }}
                  />
                  {parameterCodeErr ? <span style={errMsg}>Parameter Code can't be blank</span> : ""}
                </Grid>
                <Grid item lg={6} xs={12}>
                  <FormControl fullWidth>
                    <InputLabel id="user-role">Parameter Type</InputLabel>
                    <Select
                      labelId="user-role"
                      id="select-user-role"
                      label="Parameter Type"
                      disabled={id ? true : false}
                      value={values.parameterType}
                      onChange={handleChange("parameterType")}
                      style={{ minHeight: "44.11px" }}

                    >
                      <MenuItem value="String">String</MenuItem>
                      <MenuItem value="Number">Number</MenuItem>
                      <MenuItem value="Float">Float</MenuItem>
                      <MenuItem value="Currency">Currency</MenuItem>
                      <MenuItem value="Percentage">Percentage</MenuItem>
                      <MenuItem value="On/Off">On/Off</MenuItem>

                    </Select>

                  </FormControl>
                  {parameterTypeErr ? <span style={errMsg}>Parameter Type can't be blank</span> : ""}
                </Grid>
                <Grid item lg={6} xs={12}>
                  <TextField
                    type="text"
                    label="Parameter Length"
                    variant="outlined"
                    fullWidth
                    value={values.parameterLength}
                    inputProps={{
                      pattern: "^[0-9]+$",
                      maxLength: 10
                    }}
                    onChange={handleChange("parameterLength")}
                    disabled={values.parameterType === "On/Off" ? true : false}
                  />
                  {parameterLengthErr ? <span style={errMsg}>Parameter Length can't be blank</span> : ""}
                </Grid>
                <Grid item lg={6} xs={12}>

                  {values.parameterType === "String" &&
                    <TextField
                      type="text"
                      label="Parameter Value"
                      variant="outlined"
                      fullWidth
                      inputProps={{
                        pattern: "^[A-Za-z0-9]+$",
                        maxLength: values.parameterLength
                      }}

                      value={values.parameterValue}
                      onChange={handleChange("parameterValue")}
                    // disabled={id !== undefined}
                    />}
                  {values.parameterType === "Number" &&
                    <TextField
                      type="text"
                      label="Parameter Value"
                      variant="outlined"
                      fullWidth
                      inputProps={{
                        pattern: "^[0-9]+$",
                        maxLength: values.parameterLength
                      }}

                      value={values.parameterValue}
                      onChange={handleChange("parameterValue")}
                    // disabled={id !== undefined}
                    />}

                  {(values.parameterType === "Float" || values.parameterType === "Currency" || values.parameterType === "Percentage")
                    &&

                    <TextField
                      type="text"
                      label="Parameter Value"
                      variant="outlined"
                      fullWidth
                      inputProps={{
                        pattern: "^[0-9.]+$",
                        maxLength: values.parameterLength
                      }}

                      value={values.parameterValue}
                      onChange={handleChange("parameterValue")}
                    // disabled={id !== undefined}
                    />}
                  {values.parameterType === "On/Off" &&
                    <TextField
                      type="text"
                      label="Parameter Value"
                      variant="outlined"
                      fullWidth
                      inputProps={{
                        pattern: "^[0-9]+$",
                        maxLength: 1
                      }}

                      value={values.parameterValue}
                      onChange={handleChange("parameterValue")}
                    // disabled={id !== undefined}
                    />
                  }


                  {parameterValueErr ? <span style={errMsg}>Parameter Value can't be blank</span> : ""}
                  {parameterValueErr1 ? <span style={errMsg}>Parameter Value can be 0 and 1 </span> : ""}
                </Grid>
                <Grid item lg={6} xs={12}>
                  <FormControl fullWidth>
                    <InputLabel id="userStatus">Parameter Status </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Parameter Status"
                      value={values.parameterStatus}
                      onChange={handleChange("parameterStatus")}
                      // disabled={id !== undefined}
                      style={{ minHeight: "44.11px" }}>
                      <MenuItem value="Active">Active</MenuItem>
                      <MenuItem value="Inactive">Inactive</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item lg={12} xs={12}>
                  <TextField
                    type="text"
                    label="Parameter Instructions (Optional)"
                    variant="outlined"
                    fullWidth
                    inputProps={{
                      maxLength: 500
                    }}
                    value={values.parameterInstructions}
                    onChange={handleChange("parameterInstructions")}
                    disabled={id !== undefined}
                  />

                </Grid>
              </Grid>
            </Card>
          </Grid>
        </Grid>

        <Grid
          container
          mt={2}
          columnSpacing={{ xs: 2, md: 4, lg: 4 }}
          // columnSpacing={4}
          alignItems="center"
          display="flex"
          justifyContent="center"
        >
          <Grid item xs={12} md={4} spacing={2} lg={1.67}>

            <Link to={"/parametersetting"}>
              <MDButton
                className="btn-block center-container-btn btn-warning btn-back rightSpace"
                color="warning"
                fullWidth
                style={{ width: "165px", height: "40px" }}
              >
                Close
              </MDButton>
            </Link>
          </Grid>
          <Grid item xs={12} md={4} spacing={2} lg={1.67}>
            <MDButton
              onClick={disableColor ? blank : ParameterSettingsData}
              rel="noreferrer"
              variant="gradient"
              className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
              color={disableColor ? "secondary" : "success"}
              fullWidth
              style={{ width: "165px", height: "40px" }}
            >
              {id !== undefined ? <>Update</> : <>Save</>}

            </MDButton>
          </Grid>

        </Grid>
      </MDBox >
    </DashboardLayout >
  );
}

export default AddParameterSettings;
